import { Loader } from '@googlemaps/js-api-loader';
import LocatorResults from './front/maps/LocatorResults';
import LocatorSearch from './front/maps/LocatorSearch';
import LocatorSwitch from './front/maps/LocatorSwitch';
import Sticky from './utils/sticky';
import { createGMapPlaceholder } from './cookies-manager/placeholders';

const $map = document.querySelector('.js-locator-map');
const $head = document.querySelector('.js-locator-head');
const $results = document.querySelector('.js-locator-results');

function initLocator() {
  // Result list & map
  // const stickyLocator = new Sticky($map, $map.parentNode);
  // stickyLocator.mount();

  const results = new LocatorResults();
  results.init();

  // Autocomplete search
  const search = new LocatorSearch({
    onNewCoordinates: (latLng) => {
      results.displayInLocationRadius(latLng, 50);
      // Scroll to results (if there is coordinates)
      if (latLng) {
        window.scroll(0, window.pageYOffset + $results.getBoundingClientRect().top - 100);
      }
      // Refresh sticky position
      // stickyLocator.refresh();
    },
  });
  search.init();

  // Switch
  const $switch = document.querySelector('.js-locator-switch');
  const stickySwitch = new Sticky($switch, $switch.parentNode.parentNode);
  stickySwitch.mount();

  const lSwitch = new LocatorSwitch();
  lSwitch.init();

  $results.classList.add('is-init');
}

// Load Google API
let mapIsMounted = false;
const $placeholderHead = createGMapPlaceholder();
const $placeholderMap = createGMapPlaceholder();

$head.append($placeholderHead);
$map.append($placeholderMap);

document.addEventListener('cookies:updateChoice', (e) => {

  if(e.detail.gmaps) {
    $placeholderHead.remove();
    $placeholderMap.remove();

    if(!mapIsMounted) {
      const loader = new Loader({
        //apiKey: 'AIzaSyA1a85f9v8OOCqwHsgx3Sw9PFNJr9lAOJ8',
        apiKey: 'AIzaSyBeJONa3uN_v20iF4-Ty-J94nPaUw-y4ao',
        version: 'weekly',
        libraries: ['places'],
      });

      loader.load().then(initLocator);
      mapIsMounted = true;
    }
  } else {
    $head.append($placeholderHead);
    $map.append($placeholderMap);
  }
});
